module.exports = __webpack_public_path__ + "img/prolipa.a3e6ff1b.png";